/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMemo } from "react";
import { useConfig } from "../lib/react-query/useConfig";

export const useAssetsSrc = (assetPath) => {
  const { data: config } = useConfig();

  return useMemo(() => {
    if (!assetPath) {
      return null;
    }

    return new URL(assetPath, config.company_link);
  }, [assetPath, config.company_link]);
};
